import Header from "../Components/Header/Header";
import React, {useEffect, useState} from "react";
import {subscribeToNewsletter} from "../actions/ApiCalls";
import Footer from "../Components/Footer/Footer";
import privacy from '../static/Vinimark Website Privacy Policy.pdf';

function Subscribe() {
    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        contact_number: "",
        email: "",
        business_type: "",
        business_name: "",
        region: "",
        email_check: false,
        sms_check: false,
    });

    useEffect(() => {
        document.title = "Vinimark | Subscribe";
        window.scrollTo(0, 0);
    }, []);

    function handleChange(
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) {
        const { name, value, type } = e.target;

        if (type === "checkbox") {
            const target = e.target as HTMLInputElement; // Narrow to input for checked
            setForm((prev) => ({
                ...prev,
                [name]: target.checked,
            }));
        } else {
            setForm((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    }

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("first_name", form.first_name);
        formData.append("last_name", form.last_name);
        formData.append("contact_number", form.contact_number);
        formData.append("email", form.email);
        formData.append("business_type", form.business_type);
        formData.append("business_name", form.business_name);
        formData.append("region", form.region);
        if (form.email_check) formData.append("email_check", "on");
        if (form.sms_check) formData.append("sms_check", "on");

        subscribeToNewsletter(formData)
            .then(response => {
                if (response.data.success) {
                    alert("Thank you for subscribing to our newsletter!");
                } else {
                    alert("There was an error subscribing to our newsletter.");
                    console.error("Server response:", response.data);
                }
            })
            .catch(error => {
                console.error("Network or server error:", error);
                alert("A network error occurred. Please try again.");
            });
    }


    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            width: '100%',
            // overflow: 'hidden'
        }}>
        <Header />
            <style>{`
  .form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 75px;
  }
  @media (min-width: 836px) {
    .form-container {
      flex-direction: row;
      justify-content: center;
      gap: 20px;
    }
  }
  .content-form-field-subscribe {
    margin: 42px 0;
    width: 100%;
  }
  .checkbox-container {
    margin-top: 45px;
  }
  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;
    margin-top: 45px;
  }
  .checkbox-label input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    border: 1px solid #000;
    border-radius: 50%;
    margin-left: 4px;
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s;
  }
  .checkbox-label input[type="checkbox"]:checked {
    background-color: black;
    border-color: black;
  }
  .checkbox-label input[type="checkbox"]::before {
    content: "";
    position: absolute;
    top: 3px;
    left: 3px;
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 50%;
    transform: scale(0);
    transition: transform 0.2s;
  }

  /* Scope font size 13px only to form-container */
  .form-container input.input-email,
  .form-container select.input-email,
  .form-container .checkbox-label,
  .form-container p {
    font-size: 13px !important;
  }

  ::placeholder {
    font-size: 13px;
  }

  // /* Make footer paragraphs smaller */
  // footer p {
  //   font-size: 10px !important;
  // }
`}</style>


            <div style={{marginTop: '130px'}}>
                <div className="form-container">
                    <div style={{ flex: 1 }}></div>
                    <div style={{ flex: 1, textAlign: "left" }}>
                        <div style={{ width: window.innerWidth > 575 ? "65%" : '90%', minWidth: "300px", textAlign: "left", marginLeft: window.innerWidth > 575 ? '16px' : '24px'}}>
                            <p style={{ textTransform: "uppercase", fontWeight: 600 }}>
                                newsletter
                            </p>
                            <p>
                                Subscribe to the Vinimark newsletter to keep up to date with the latest wine news, awards, vintage and product releases.
                            </p>
                            <form onSubmit={handleSubmit} style={{ marginTop: "50px" }}>
                                <div className="content-form-field-subscribe">
                                    <input
                                        type="text"
                                        name="first_name"
                                        className="input-email"
                                        placeholder="Enter Name"
                                        value={form.first_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="content-form-field-subscribe">
                                    <input
                                        type="text"
                                        name="last_name"
                                        className="input-email"
                                        placeholder="Enter Surname"
                                        value={form.last_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="content-form-field-subscribe">
                                    <input
                                        type="text"
                                        name="contact_number"
                                        className="input-email"
                                        placeholder="Enter Contact Number"
                                        value={form.contact_number}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="content-form-field-subscribe">
                                    <input
                                        type="text"
                                        name="email"
                                        className="input-email"
                                        placeholder="Enter Email Address"
                                        value={form.email}
                                        onChange={handleChange}
                                        required
                                    />
                                    <br/>
                                    <p style={{color: 'gray'}}>We'll never share your email with anyone else</p>
                                </div>
                                <div className="content-form-field-subscribe">
                                    <select
                                        name="business_type"
                                        className="input-email"
                                        value={form.business_type}
                                        onChange={handleChange}
                                        required
                                        style={{color: 'black'}}
                                    >
                                        <option value="" disabled>
                                            Select Business Type
                                        </option>
                                        <option value="Restaurant / OnCon">
                                            Restaurant / OnCon
                                        </option>
                                        <option value="Retail / OffCon">Retail / OffCon</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>

                                <div className="content-form-field-subscribe">
                                    <input
                                        type="text"
                                        name="business_name"
                                        className="input-email"
                                        placeholder="Enter Business Name"
                                        value={form.business_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

                                <div className="content-form-field-subscribe">
                                    <select
                                        name="region"
                                        className="input-email"
                                        value={form.region}
                                        onChange={handleChange}
                                        required
                                        style={{color: 'black'}}
                                    >
                                        <option value="" disabled>
                                            Select Location
                                        </option>
                                        <option value="Eastern Cape">Eastern Cape</option>
                                        <option value="Free State">Free State</option>
                                        <option value="Gauteng">Gauteng</option>
                                        <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                                        <option value="Limpopo">Limpopo</option>
                                        <option value="Mpumalanga">Mpumalanga</option>
                                        <option value="North West">North West</option>
                                        <option value="Northern Cape">Northern Cape</option>
                                        <option value="Western Cape">Western Cape</option>
                                        <option value="International">International</option>
                                    </select>
                                </div>

                                <div className="checkbox-container">
                                    <label className="checkbox-label" style={{fontSize: '13px', lineHeight: '16.9px'}}>
                                        <input
                                            type="checkbox"
                                            name="email_check"
                                            checked={form.email_check}
                                            onChange={handleChange}
                                        />
                                        Receive Email
                                    </label>
                                    <label className="checkbox-label" style={{marginTop: '20px', fontSize: '13px', lineHeight: '16.9px'}}>
                                        <input
                                            type="checkbox"
                                            name="sms_check"
                                            checked={form.sms_check}
                                            onChange={handleChange}
                                        />
                                        Receive SMS
                                    </label>
                                </div>
                                <br />
                                <p>
                                    By clicking "Sign up", I hereby confirm that I consent to Vinimark Trading (Pty) Ltd ("Vinimark") processing my personal information for the purpose of receiving direct marketing communications via my preferred channel, relating to Vinimark's range of wines, wine-related events, and promotional offers.
                                </p>
                                <p>You may withdraw your consent at any time by clicking the unsubscribe link in our emails.</p>
                                <p>For more information about how your personal information is processed, please visit our <a href={privacy}>Privacy Policy</a></p>
                                <div
                                    className="content-form-button"
                                    style={{ width: "100%", marginTop: "20px" }}
                                >
                                    <button className="button" style={{ width: "100%", marginBottom: '100px' }} type="submit">
                                        Sign Up
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Subscribe;
